
  import {
    defineComponent,
    onMounted,
    ref,
    computed,
    watchEffect,
    watch,
  } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import Multiselect from '@vueform/multiselect';

  export default defineComponent({
    name: 'registered-trades-grouping-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
      Multiselect,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const selectedDescriptionIds = ref<number[]>([]);
      const registeredDescs = computed(
        () => store.getters.getRegisteredDesc || []
      );

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('registeredTradesGroupingUpdate'), [
          translate('registered-trades'),
        ]);
        await store.dispatch(Actions.GET_REGISTERED_TRADES_ASSETS, 6);
        if (
          registeredDescs.value.length > 0 &&
          grouping.value.relatedIds?.length
        ) {
          selectedDescriptionIds.value = grouping.value.relatedIds.slice();
        }
      });
      const { data } = await store.dispatch(
        Actions.GET_REGISTERED_TRADES_GROUPING,
        route.params.id
      );

      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const goBack = () => {
        router.back();
      };

      const grouping = ref<any>(data.data);
      const icon = ref(grouping.value.icon);

      if (grouping.value?.relatedIds) {
        selectedDescriptionIds.value = grouping.value.relatedIds.slice();
      }

      const previewImage = (e) => {
        const file = e.target.files[0];
        icon.value = URL.createObjectURL(file);
      };

      const groupingSchema = Yup.object().shape({
        titleEn: Yup.string()
          .required(() => translate('EN_NAME_IS_REQUIRED_FIELD'))
          .label('English Name'),
        titleAr: Yup.string()
          .required(() => translate('AR_NAME_IS_REQUIRED_FIELD'))
          .label('Arabic Name'),
      });

      const onSubmitUpdate = async (values) => {
        values.relatedIds = Array.isArray(selectedDescriptionIds.value)
          ? selectedDescriptionIds.value.slice()
          : [];
        if (submitButton.value) {
          // eslint-disable-next-line
        submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        if (values.sort) {
          values.sort = Number(values.sort);
        }

        let iconFormData;
        if (values.icon) {
          iconFormData = new FormData();
          iconFormData.append('images', values.icon);
          delete values.icon;
        }

        delete values.icon;
        await store.dispatch(Actions.UPDATE_REGISTERED_TRADES_GROUPING, {
          id: route.params.id,
          data: values,
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
        submitButton.value!.disabled = false;
        } else {
          if (iconFormData) {
            await store.dispatch(Actions.UPLOAD_REGISTERED_TRADES_ICON, {
              data: iconFormData,
              groupingId: route.params.id,
            });
          }
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_REGISTERED_TRADES_GROUPING'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'registered-trades-grouping-listing' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        onSubmitUpdate,
        submitButton,
        translate,
        groupingSchema,
        previewImage,
        goBack,
        grouping,
        icon,
        can,
        registeredDescs,
        selectedDescriptionIds,
      };
    },
  });
